export const serializeCountryName = (name: string) => {
  return name
    .replace(/[_\s]+/g, ' ')
    .split(' ')
    .map(s => s.replace(/^[a-z]/, m => m.toUpperCase()))
    .join(' ');
};
